<template>
    <div>
        <router-link tag="a" class="back-button right mb11" to="/portfolio">Back to portfolio</router-link>
        <h6 class="headline-sm">Military</h6>
        <ul class="portfolio-list">
            <li>
                <img img src="images/Our-Work-Page/Military/military1.png" alt="">
                <strong class="portfolio-list-name">Veterans Memorial Pavilion</strong>
                <span class="portfolio-list-location">Attleboro, MA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Military/military2.png" alt="">
                <strong class="portfolio-list-name">VFW Patriots Walk</strong>
                <span class="portfolio-list-location">Boise, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Military/military3.png" alt="">
                <strong class="portfolio-list-name">American Legion Post 49</strong>
                <span class="portfolio-list-location">Emmett, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Military/military4.png" alt="">
                <strong class="portfolio-list-name">Elks Lodge #1683</strong>
                <span class="portfolio-list-location">Weiser, ID</span>
            </li>
        </ul>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'military',
        metaInfo: {
            title: 'Military Venues'
        }
    }
</script>



// WEBPACK FOOTER //
// Military.vue?5c4652b4